import { render } from "./ImmobilienIcon.vue?vue&type=template&id=6270ba3a"
import script from "./ImmobilienIcon.vue?vue&type=script&lang=js"
export * from "./ImmobilienIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__